// 값을 그대로 이어붙이면 `&`·`#`·`+`·`%` 가 들어간 병원명/주소가 쿼리 문법으로 해석된다.
//   `S&U의원`        → storeName=S 로 잘리고 `U의원` 이 별도 파라미터가 된다
//   `닥터#의원`      → `#` 뒤가 전부 fragment 가 되어 뒤따르는 파라미터가 통째로 사라진다
//   `연세플러스+치과` → 서버가 `+` 를 공백으로 디코딩한다
// 같은 화면에서 POST 본문(JSON)은 원본 그대로 보내므로, 조회와 등록이 서로 다른 병원명을
// 쓰게 되어 "조회는 없다고 하는데 등록은 중복" 인 상태가 만들어진다.
// 목록 구분자 `,` 는 서버 계약이므로 원소별로 인코딩하고 구분자는 그대로 둔다.
const encodeQueryValue = (value: unknown): string => (Array.isArray(value) ? value.map((item) => encodeURIComponent(String(item))).join(',') : encodeURIComponent(String(value)));

export const convertQueryParam = (params: object | undefined) => {
  if (params === undefined || Object.keys(params)?.length === 0) {
    return '';
  }

  let paramString = '';

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      paramString = `${paramString}${encodeURIComponent(key)}=${encodeQueryValue(value)}&`;
    }
  });

  return paramString !== '' ? `?${paramString.substring(0, paramString.length - 1)}` : paramString;
};
